__turbopack_context__.v({
  "container": "ComparisonCheckbox-module-scss-module__z0etKG__container",
  "pdp": "ComparisonCheckbox-module-scss-module__z0etKG__pdp",
});
